export default __webpack_public_path__ + "static/media/proa-thumbnail.bfd1d484.jpg";